<nav *ngIf="pagination && (items.length > 1)" aria-label="Pagination Bar" class="{{parentSelector}}">
    <ul class="pcg-pagination pcg-contrast-pagination">
        <li *ngFor="let item of items" class="pcg-pagination__item">
            <a *ngIf="item.hasUrl()" href="{{item.navigationUrl}}"
               class="{{item.buttonStyle}}"
               [ngClass]="{ 'active' : item.isCurrentPage }"
               [attr.aria-current]="item.isCurrentPage"
               (click)="onPageNumberClicked(item.pageNumber)">{{item.displayLabel}}
            </a>
            <ng-container *ngIf="!item.hasUrl()" class="{{item.buttonStyle}}">{{item.displayLabel}}</ng-container>
        </li>
    </ul>
</nav>
